import { preconnect, preload } from '@rea-argonaut/actions';
import { isNotNullOrUndefinedValue } from '../../helpers/isNotNullOrUndefinedValue';
import { ResourceHint } from '../entry/types';

export const getFilteredDNSPreFetchAttributes = (hint: ResourceHint): string => {
  /*
    We need to ensure nullable/falsy attributes are omitted
    We also need to rename underscored to dash (limitation of GQL)
    e.g
    <link rel="dns_prefetch" href="https://i2.au.reastatic.net" as={null} type={null} crossorigin={null}>
    should actually be
    <link rel="dns-prefetch" href="https://i2.au.reastatic.net">

  */
  return Object.entries(hint)
    .map(([key, value]): string | null => {
      if (!value || key === '__typename') return null;
      if (key === 'rel' && value === 'dns_prefetch') return `rel="dns-prefetch"`;
      return `"${key}"="${value}"`;
    })
    .filter(isNotNullOrUndefinedValue)
    .join(' ');
};

export const getResourceHints = (resourceHints?: ResourceHint[] | null): string[] => {
  if (!resourceHints || !resourceHints.length) return [];

  return resourceHints.map((hint): string => {
    switch (hint.rel) {
      case 'preconnect':
        return preconnect(hint.href);

      case 'preload':
        return preload({
          href: hint.href,
          as: hint.as || 'script',
          type: hint?.type || undefined,
          crossorigin: hint?.crossorigin ? true : undefined,
        });
        break;

      case 'dns_prefetch':
        //Argonaut doesnt have this out of the box
        return `<link ${getFilteredDNSPreFetchAttributes(hint)} />`;
        break;
    }
  });
};
